import { Box, Grid as ChakraGrid } from '@chakra-ui/react';
import { CountrySelector } from 'components/localisation/CountrySelector';
import { useIsCampaignPage } from 'hooks/useIsCampaignPage';
import { env } from 'lib/constants/env';

import { RESPONSIVE_BP } from './constants';
import { HeaderNavItem } from './HeaderNavItem';
import { useNav } from './useNav';

export const SecondaryNav = () => {
  const { secondaryNav } = useNav();
  const isCampaignPage = useIsCampaignPage();

  const showCountrySelector = env.NEXT_PUBLIC_COUNTRY_SELECTOR_ENABLED;
  const showNavItems = !isCampaignPage;

  if (!showCountrySelector && !showNavItems) {
    return null;
  }

  return (
    <ChakraGrid
      display={{ base: 'none', [RESPONSIVE_BP]: 'grid' }}
      gridAutoFlow="column"
      alignItems="center"
      gap={{ base: 'sm', [RESPONSIVE_BP]: 'sm' }}
    >
      {showCountrySelector && (
        <Box mr="-4xs">
          <CountrySelector variant="overline" />
        </Box>
      )}
      {showNavItems &&
        secondaryNav.map((sr, i) => (
          <HeaderNavItem
            key={i}
            href={sr.href}
            name={sr.name}
            isExternal={sr.isExternal}
            onClick={sr.onClick}
          >
            {sr.label}
          </HeaderNavItem>
        ))}
    </ChakraGrid>
  );
};
